import type { ListingLabel as ListingLabelEnum } from '@bb/automaton';
import axios from 'axios';

export type ListingLabel = keyof typeof ListingLabelEnum;

export type ListingLabelOverride = {
  label: ListingLabel;
  override: string;
  hideLabel: boolean;
}[];

const getListingLabelOverride = async ({
  onboardingPortalId,
  dashboardId,
  retsId,
}: {
  onboardingPortalId: string;
  dashboardId?: string | undefined;
  retsId?: string | undefined;
}) => {
  if (!onboardingPortalId) return [];

  const queryParams = addQueryParams({ dashboardId, retsId });
  const url = `/onboarding-portal/${onboardingPortalId}/listing-label-override`;

  const { data } = await axios.get<ListingLabelOverride>(url, {
    params: queryParams,
  });

  return data;
};

const addQueryParams = ({
  dashboardId,
  retsId,
}: {
  dashboardId?: string;
  retsId?: string;
}) => {
  const queryParams: Record<string, string> = {};
  if (dashboardId) {
    queryParams.dashboardId = dashboardId;
  }
  if (retsId) {
    queryParams.retsId = retsId;
  }
  return queryParams;
};

export default getListingLabelOverride;
